import { render } from "./InfiniteScroll.vue?vue&type=template&id=7c73fd8e"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\GhanaWaterHelpCenter\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__